export enum SearchActionType {
  QUICK = "quick",
  DETAIL = "detail"
}
